(function ($) {
  let searchParams = new URLSearchParams(window.location.search);
  let params = searchParams.getAll("filter");
  let filterItems = Array.from($(".filter-list-item"));

  if (searchParams.get("filter")) {
    let paramsArr = params.toString().split(",");
    $(".filter-btn").addClass("open");
    $(".filters-container").toggleClass("hidden");
    for (let param of paramsArr) {
      filterItems.forEach((item) => {
        let slug = $(item).data("slug").replace("-", " ");
        if (slug == param) {
          $(item).toggleClass("active-filter");
        }
      });
    }
  }

  $(".filter-btn").on("click", function () {
    $(this).toggleClass("open");
    $(".filters-container").toggleClass("hidden");
  });

  //POSTS STYLING
  let postsContainers = Array.from($(".filtered-posts-container"));
  let posts = $(postsContainers).children();

  //Reading time
  for (let post of posts) {
    let postDate = $(post).find(".hg-filter-bubble__date");
    let readingTime = $(post).find("span.rt-reading-time");
    $(postDate).after(readingTime);

    //Remove featured category display
    let featuredTag = $(post).find(".hg-filter-bubble__cat").text();
    let newCatList = featuredTag.replace(" Featured", "");
    $(post).find(".hg-filter-bubble__cat").text(newCatList);

    //Color category
    featuredCategoryColor($(post).find(".hg-filter-bubble__cat").text(), post);
  }
  function featuredCategoryColor(text, post) {
    switch (text) {
      case "Ethik aktuell":
        $(post).find(".hg-filter-bubble__cat").addClass("aktuell");
        break;
      case "Ethik bildung":
        $(post).find(".hg-filter-bubble__cat").addClass("bildung");
        break;
      case "Ethik essay":
        $(post).find(".hg-filter-bubble__cat").addClass("essay");
        break;
      default:
        break;
    }
  }
})(jQuery);
